import { useCallback } from 'react';

const STATS = [
  { value: '10万+', label: '高清片源' },
  { value: '每日更新', label: '同步上线' },
  { value: '全网加速', label: '流畅不缓冲' },
];

export default function Hero() {
  const scrollTo = useCallback((id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  }, []);

  const handleImgError = useCallback((e: React.SyntheticEvent<HTMLImageElement>) => {
    e.currentTarget.setAttribute('data-failed', 'true');
  }, []);

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden pt-16"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-50 via-background-100/90 to-background-200/80"></div>

      <div className="absolute top-0 right-0 w-full md:w-3/5 h-full opacity-30 md:opacity-40">
        <div className="absolute inset-0 bg-gradient-to-l from-transparent via-background-50/60 to-background-50"></div>
      </div>

      <div className="relative w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left pt-8 md:pt-0">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-500/15 border border-accent-500/25 mb-6">
              <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
              <span className="text-xs md:text-sm font-medium text-accent-400 whitespace-nowrap">
                聚合全网高清影视资源
              </span>
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-foreground-50 font-heading leading-tight text-balance">
              麻花影视
              <span className="block text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-foreground-200 font-bold mt-2">
                电影大全高清影视免费在线观看
              </span>
            </h1>

            <p className="mt-4 text-base md:text-lg text-primary-400 font-medium font-heading">
              飘花电影网 · 555电影 · 8090电影网联合推荐
            </p>

            <p className="mt-6 text-sm md:text-base text-foreground-400 leading-relaxed max-w-xl mx-auto lg:mx-0">
              麻花影视聚合飘花电影网、555电影、8090电影网等主流高清影视平台资源，每日同步更新最新电影、热播电视剧、热门综艺节目。片库涵盖动作、喜剧、科幻、悬疑、武侠、爱情、动画等全类型内容，支持多设备流畅播放，无需注册即可免费在线观看，真正实现一站式追剧观影体验。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mt-8">
              {STATS.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-xl md:text-2xl font-black text-foreground-50 font-heading">
                    {stat.value}
                  </div>
                  <div className="text-xs md:text-sm text-foreground-500 mt-1">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-8">
              <button
                onClick={() => scrollTo('index')}
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-lg text-sm transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-movie-2-line mr-2"></i>
                开始观影
              </button>
              <button
                onClick={() => scrollTo('updates')}
                className="w-full sm:w-auto px-8 py-3 bg-background-200/70 hover:bg-background-300/70 text-foreground-200 font-medium rounded-lg text-sm border border-background-300/40 transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line mr-2"></i>
                最新动态
              </button>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end mt-4 lg:mt-0">
            <div className="relative w-[280px] h-[360px] sm:w-[340px] sm:h-[440px] md:w-[400px] md:h-[500px] rounded-2xl overflow-hidden border border-background-300/40 bg-background-200/40">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20collage%20with%20warm%20golden%20spotlights%20illuminating%20floating%20film%20strips%20and%20classic%20movie%20elements%2C%20dark%20theater%20atmosphere%20with%20rich%20amber%20and%20deep%20charcoal%20tones%2C%20dramatic%20lighting%20with%20lens%20flares%2C%20elegant%20cinematic%20composition%20with%20film%20reels%20and%20projector%20light%20beams%2C%20luxurious%20movie%20poster%20aesthetic%2C%20warm%20gold%20and%20crimson%20accents%20on%20dark%20background%2C%20sophisticated%20film%20noir%20inspired%20visual%20design&width=800&height=1000&seq=mahua-hero-visual&orientation=portrait"
                alt="麻花影视 - 高清影视聚合平台"
                className="w-full h-full object-cover"
                onError={handleImgError}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-50/70 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}